import React from 'react';
import BaseComponent from 'meta/features/base-component';
import cn from 'classnames';
import Icon from 'meta/ui2/icon';
class Button extends BaseComponent {
    static defaultProps = {
        type: 'primary',
        size: 'md',
        isFixed: false,
        isActive: true,
        disabled: false,
        isLoading: false
    };
    innerElement;
    element;
    constructor(props) {
        super(props);
        this.innerElement = null;
        this.element = null;
        this._bind('_getContent', '_handleOnClick');
    }
    _getContent() {
        let { children, text, isLoading } = this.props;
        let content = children || text;
        let spinner = isLoading ? <Icon name="cog" spin/> : null;
        return (<div ref={c => this.innerElement = c}>
                {content} {spinner}
            </div>);
    }
    _handleOnClick(e) {
        let { onClick, disabled } = this.props;
        if (this.element)
            e.currentTarget = this.element;
        if (!disabled)
            onClick(e);
    }
    render() {
        let { type, text, width, disabled, isActive, isFixed, isLoading, size, style, className, ...restProps } = this.props;
        let buttonClassName = cn('ui2-btn', `ui2-btn-${type}`, className, {
            [`ui2-btn-${size}`]: true,
            'disabled': disabled || isLoading,
            'active': isActive
        });
        let buttonStyle = {};
        if (style)
            Object.assign(buttonStyle, style);
        if (width)
            buttonStyle.width = width;
        if (isLoading && buttonStyle.width && !isFixed && typeof buttonStyle.width === 'number')
            buttonStyle.width += 20;
        return (<a {...restProps} onClick={this._handleOnClick} style={buttonStyle} className={buttonClassName} ref={c => this.element = c}>
                {this._getContent()}
            </a>);
    }
}
export default Button;
